import Config from "@app/dev/config/main";
import { PhoneFields } from "@app/dev/terminal/components/requestPayoutPopup/components/phoneFields";

export const defaultRegisterFields = [
  {
    name: 'customPhoneNumber',
    fieldName: 'Phone',
    custommComponent: PhoneFields,
    placeHolder: Config.main.registartionCustomField.registrationPhoneplaceHolder,
    maxLength: Config.main.registartionCustomField.phoneNumberLength,
  },
  // {
  //   name: 'email',
  //   fieldName: 'Email',
  // },
  {
    name: 'password',
    fieldName: 'Password',
    type: 'password',
  },
  {
    name: 'confirmPassword',
    fieldName: 'Confirm Password',
    type: 'password',
  },
];
